module.exports = __webpack_public_path__ + "static/media/premium_user_banner.f95cbcaf.png";